import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

// Registro único y centralizado de los componentes de Chart.js usados por el
// dashboard. Antes cada sección llamaba a ChartJS.register(...) por su cuenta;
// importar este módulo una vez evita la duplicación. El registro es idempotente.
ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
);
